import Reveal from "@/components/Reveal";
import { BookButton, CallButton, EmergencyNote } from "@/components/CTA";

export default function CtaBand({
  title = "Care that fits your life starts here.",
  accent = "starts here.",
  sub = "Book online in under a minute, or call us for a same-day appointment.",
  testidPrefix = "cta-band",
}) {
  return (
    <section data-testid={`${testidPrefix}-section`} className="bg-brand-navy">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 md:py-24 lg:px-12">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">
            Now Accepting New Patients
          </p>
          <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            {title.replace(accent, "")}
            <span className="font-serif italic text-brand-red">{accent}</span>
          </h2>
          <p className="mt-4 max-w-xl text-base text-slate-300">{sub}</p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <BookButton testid={`${testidPrefix}-book-online-btn`} />
            <CallButton
              testid={`${testidPrefix}-call-btn`}
              variant="light"
              label="Call for Same-Day Care"
            />
          </div>
          <EmergencyNote testid={`${testidPrefix}-emergency-note`} light className="mt-6" />
        </Reveal>
      </div>
    </section>
  );
}
